import apiClient from '../utils/apiClient';

// Get all activity types for the company
export async function getActivityTypes() {
  const response = await apiClient.get('/api/activity-types/');
  return response.data;
}

// Search activity types by query (for autocomplete)
export async function searchActivityTypes(query = "") {
  const response = await apiClient.get('/api/activity-types/search', {
    params: query ? { query } : {}
  });
  return response.data;
}

// Create a new activity type
export async function createActivityType({ name, color, description }) {
  const response = await apiClient.post('/api/activity-types/', { name, color, description });
  return response.data;
}

// Update an activity type
export async function updateActivityType(activityTypeId, { name, color, description }) {
  const response = await apiClient.put(`/api/activity-types/${activityTypeId}`, { name, color, description });
  return response.data;
}

// Delete an activity type
export async function deleteActivityType(activityTypeId) {
  const response = await apiClient.delete(`/api/activity-types/${activityTypeId}`);
  return response.data;
}